var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearPromo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90388 0.298426C9.50594 -0.0995218 8.86068 -0.0994685 8.46267 0.298545L5.1012 3.66001L1.80419 0.362994C1.40624 -0.0349537 0.760987 -0.0349004 0.362974 0.363113C-0.0350395 0.761126 -0.0350928 1.40638 0.362855 1.80433L3.65987 5.10134L0.298545 8.46267C-0.0994688 8.86068 -0.0995218 9.50594 0.298426 9.90388C0.696375 10.3018 1.34163 10.3018 1.73964 9.90377L5.10097 6.54244L8.39808 9.83956C8.79603 10.2375 9.44128 10.2375 9.8393 9.83944C10.2373 9.44143 10.2374 8.79617 9.83942 8.39822L6.5423 5.10111L9.90377 1.73964C10.3018 1.34163 10.3018 0.696373 9.90388 0.298426Z",
    fill: "#C1C1C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearPromo);
export default __webpack_public_path__ + "static/media/clearPromo.db1557b26a3724dec033384ba58d7147.svg";
export { ForwardRef as ReactComponent };